"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _mixins = require("../../styles/mixins");
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _HBTableCell = _interopRequireWildcard(require("./HBTableCell"));
var _HBTable = require("./HBTable.styles");
var _shared = require("../../utils/shared.utils");
var _animations = require("../../styles/animations");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function HBTableRow(_ref) {
  var table = _ref.table,
    row = _ref.row,
    isLoading = _ref.isLoading;
  var _table$options$meta = table.options.meta,
    onRowClick = _table$options$meta.onRowClick,
    bulkActions = _table$options$meta.bulkActions,
    helper = _table$options$meta.helper;
  var hasBulkActions = (bulkActions === null || bulkActions === void 0 ? void 0 : bulkActions.length) > 0;

  // if bulk actions are provided and, the onRowClick was not, clicking the row will toggle its selection.
  var isClickable = !!onRowClick || hasBulkActions;
  return /*#__PURE__*/_react["default"].createElement(TR
  // I want rows to be focusable even if there's no onRowClick so that you could still navigate the the rows using the keyboard
  , {
    tag: "tr",
    inert: isLoading,
    $isClickable: isClickable,
    "data-is-selected": helper.isTableRowSelected(row),
    onClick: function onClick(e) {
      if (isClickable && (e.currentTarget === document.activeElement || e.currentTarget.matches(_mixins.directHoverGlobalSelector))) {
        if (e.key === ' ') {
          // If space was pressed to toggle row selection, prevent it from scrolling the page
          e.preventDefault();
        }
        if (onRowClick) {
          onRowClick(row.original);
        } else if (hasBulkActions) {
          helper.toggleTableRowSelection(row);
        }
      }
    }
  }, table.getAllColumns().map(function (column) {
    return /*#__PURE__*/_react["default"].createElement(_HBTableCell["default"], {
      table: table,
      key: column.id,
      column: column,
      row: row,
      isLoading: isLoading
    });
  }));
}
var _default = exports["default"] = HBTableRow; // -------------------------- Styles -------------------------- //
var TR = (0, _styledComponents["default"])(_HBClickable["default"]).attrs(_shared.inertAttr).withConfig({
  displayName: "HBTableRow__TR",
  componentId: "sc-qp8kk7-0"
})(["&&{background-color:", ";transition:background-color 60ms;opacity:1;&[inert]{transition:opacity 100ms;opacity:0.3;}&:not(:last-child){border-bottom:1px solid ", ";}&:focus-visible{position:relative;z-index:", ";}&[data-is-selected='true'],&:focus-visible,&:focus-within,&:has([data-state='open']),&:has([data-popover-state='open']){background-color:", ";.", "{opacity:1;}}", " .", "{opacity:0;", "}&:hover{.", "{opacity:1;}}}"], _colors["default"].white, _colors["default"].neutral100, _HBTable.TABLE_Z_INDEX.MIDDLE, _colors["default"].neutral100, _HBTableCell.showWhenRowHoveredClassName, function (props) {
  return props.$isClickable ? (0, _styledComponents.css)(["&:hover{background-color:", ";}"], _colors["default"].neutral100) : (0, _styledComponents.css)(["cursor:default;"]);
}, _HBTableCell.showWhenRowHoveredClassName, (0, _animations.transition)('opacity'), _HBTableCell.showWhenRowHoveredClassName);
HBTableRow.TR = String(TR);
//# sourceMappingURL=HBTableRow.js.map